
import {defineComponent, PropType} from "vue";
import {Campaign} from "@/models/campaign";
import NetworkImageComponent from "@/components/NetworkImageComponent.vue";

export default defineComponent({
    name: "SmallHeaderComponent",
    components: {NetworkImageComponent},
    props: {
        campaign: { type: Object as PropType<Campaign>, required: true },
        promptText: { type: String, required: true }
    },
    computed: {
        image() {
            if (this.campaign?.image) {
                return this.campaign.image;
            }

            if (this.campaign?.profile.image) {
                return this.campaign.profile.image;
            }

            return null;
        },
    },
});
